import AcceptTOSModalComponent from './accept-tos-modal.component'

const AcceptTOSModalModule = angular.module('cdbl.accept-tos-modal', [

])
  .component('cdblAcceptTosModal', AcceptTOSModalComponent)
  .name

export default AcceptTOSModalModule
